// ------------------------------------
// Constants
// ------------------------------------
export const BLOCK_UI = 'BLOCK_UI'

// ------------------------------------
// Actions
// ------------------------------------
export function toggleBlockUI (value = true) {
  return {
    type    : BLOCK_UI,
    payload : value
  }
}

export const actions = { toggleBlockUI }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BLOCK_UI] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = false
export default function blockUIReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/blockUI.js